
import { Component } from 'vue-property-decorator';

// API
import { getAllProjects } from '@/utils/api/Projects';

// Components
import VAdministrationMain from '@/components/Administration/VAdministrationMain.vue';
import VAdministrationHeader from '@/components/Administration/VAdministrationHeader.vue';
import VPageTitle from '@/components/Administration/VPageTitle.vue';

import VAdministrationActionbar from '@/components/Administration/VAdministrationActionbar.vue';
import VAdministrationPrimaryTable from '@/components/Administration/VAdministrationPrimaryTable.vue';

// Mixins
import VAdministrationPrimaryTableMixin from '@/mixins/VAdministrationPrimaryTableMixin';

// Enums
import AdministrationPageNamesEnum from '@/ship/Enums/AdministrationPageNamesEnum';

// Interfaces
import Project from '@/ship/Models/Project';
import { GetRequestParams } from '@/ship/Requests/RequestParams';

@Component({
    components: {
        VAdministrationMain,
        VAdministrationHeader,
        VPageTitle,

        VAdministrationActionbar,
        VAdministrationPrimaryTable,
    },
})
export default class ProjectsPage extends VAdministrationPrimaryTableMixin {
    readonly currentPageName = AdministrationPageNamesEnum.Projects;
    readonly request = getAllProjects;

    declare items: Project[];

    get transformedProjects() {
        return this.items.map(({ id, project, address, city }) => {
            return {
                id,
                project,
                address: address ?? this.$t('page.administration.addressNotStated'),
                city: city?.data.name ?? this.$t('page.administration.cityNotStated'),
            };
        });
    }

    public getRequestParams(): GetRequestParams {
        const cityFilter = this.searchCityId ? `city_id:${this.searchCityId};` : '';
        const searchFilter = this.search ? `id,city.name,project,address:${this.search};` : '';

        return {
            filter: 'id;project;address;name',
            include: 'city',
            search: cityFilter + searchFilter,
        };
    }
}
